module.exports = __webpack_public_path__ + "static/media/zagreb.31e35266.jpg";